/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SeasonLinkTypeBundle {
    LINK = 'LINK',
    MAILTO = 'MAILTO',
}
